export default "__VITE_ASSET__CsJe5yjO__"